import React from "react";
import { FiCheck, FiTrash2, FiX } from "react-icons/fi";

interface BulkActionBarProps {
  selectedCount: number;
  totalCount: number;
  selectAllMode: boolean;
  onMarkRead: () => void;
  onClear: () => void;
  onDeselectAll: () => void;
}

const BulkActionBar: React.FC<BulkActionBarProps> = ({
  selectedCount,
  totalCount,
  selectAllMode,
  onMarkRead,
  onClear,
  onDeselectAll
}) => {
  if (selectedCount === 0 && !selectAllMode) return null;

  const displayCount = selectAllMode ? totalCount : selectedCount;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 bg-[#010D2C] text-white shadow-2xl rounded-full px-6 py-3 flex items-center gap-6 border border-slate-700/50 animate-bounce-once">
      <div className="flex items-center gap-2">
        <span className="bg-white text-[#010D2C] text-xs font-black min-w-5 h-5 px-1.5 rounded-full flex items-center justify-center">
          {displayCount}
        </span>
        <span className="text-sm font-semibold tracking-wide text-slate-200">
          {selectAllMode ? "all selected" : "selected"}
        </span>
      </div>

      <div className="h-4 border-r border-slate-700" />

      <div className="flex items-center gap-4">
        <button
          onClick={onMarkRead}
          className="flex items-center gap-1.5 text-sm font-bold text-slate-200 hover:text-[#58CC02] transition-colors"
        >
          <FiCheck className="w-4 h-4" />
          Mark as read
        </button>

        <button
          onClick={onClear}
          className="flex items-center gap-1.5 text-sm font-bold text-slate-200 hover:text-red-400 transition-colors"
        >
          <FiTrash2 className="w-4 h-4" />
          Delete
        </button>

        <button
          onClick={onDeselectAll}
          className="flex items-center gap-1.5 text-sm font-bold text-slate-400 hover:text-slate-200 transition-colors"
        >
          <FiX className="w-4 h-4" />
          Cancel
        </button>
      </div>
    </div>
  );
};

export default BulkActionBar;
